export const careersData = [
	{
		id: 1,
		company: "KIKUYU WATER COMPANY LIMITED",
		title: "Technical Manager",
		location: "Kikuyu",
		deadline: "2026-10-23T17:00:00",
		documentUrl:
			"/documents/careers/KIKUYU%20WATER%20COMPANY%20LIMITED%20ADVERT.pdf",
		applyDocumentUrl:
			"/documents/careers/VACANCY%20ADVERTISEMENT%20-%20TECHNICAL%20MANAGER%20KIKUYU%20WATER%20COMPANY%20LTD.pdf",
	},
];

export default careersData;
